import { render, staticRenderFns } from "./cardTemplateVip18.vue?vue&type=template&id=66b259ac&scoped=true&"
import script from "./cardTemplateVip18.vue?vue&type=script&lang=js&"
export * from "./cardTemplateVip18.vue?vue&type=script&lang=js&"
import style0 from "./cardTemplateVip18.vue?vue&type=style&index=0&id=66b259ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b259ac",
  null
  
)

export default component.exports